import { Permission, type SkillManifest } from '@brandschutz/shared';
import type { FrontendSkill } from '../_core/registry';

/**
 * Schlanker Skill-Descriptor — wird vom Bootstrap importiert, OHNE den Barrel
 * (PrueferListPage, FormModal, PickerField) eager zu laden. Die Listenseite
 * kommt über die Lazy-Route in App.tsx.
 */
const manifest: SkillManifest = {
  key: 'pruefer',
  name: 'Prüfsachverständige',
  description: 'PSV/PfB-Stammdaten — werden im ProjectForm und in Behördenvorgängen referenziert.',
  category: 'core',
  version: '0.1.0',
  requiredPermissions: [Permission.PRUEFER_READ],
  enabledByDefault: true,
};

export const prueferSkill: FrontendSkill = {
  manifest,
  slots: {},
};
